import { CommandResult } from '../amorg-common'
import { Survey } from '../amorg-common'
import { SurveyAnswerStatus } from '../amorg-common'
import { SurveySegment } from '../amorg-common'
import { queryAuthWrapper, commandAuthWrapper } from "./serverApiHelpers";
import { surveysPath } from "./surveyClientApi";

export async function getSurveyAsAnonymous(siteId: string, surveyId: string): Promise<Survey | null>
{
    try {
        const result = await queryAuthWrapper(`${surveysPath}/${siteId}.${surveyId}`);
        return result === null
            ? null
            : { ...result, start: new Date(result.start), end: new Date(result.end) };

    } catch (error) {
        return null;
    }
}

export const startAnswer = async (siteId: string, surveyId: string, email: string): Promise<CommandResult> =>
    (await commandAuthWrapper(`${surveysPath}/${siteId}.${surveyId}/answers`, 'POST', { email }));

// target is an optional stage request: 'intro' | 'segmentations' | 'question:<index>'.
// When omitted, the server returns the default resume stage.
export const getAnswerStatus = async (siteId: string, surveyId: string, answerId: string, target?: string): Promise<SurveyAnswerStatus> =>
    (await queryAuthWrapper(`${surveysPath}/${siteId}.${surveyId}/answers/${answerId}${target ? `?target=${target}` : ''}`));

export const submitSegments = async (siteId: string, surveyId: string, answerId: string, segments: SurveySegment[]): Promise<CommandResult> =>
    (await commandAuthWrapper(`${surveysPath}/${siteId}.${surveyId}/answers/${answerId}/segments`, 'POST', { segments }));

// submitting undefined as comment will leave a possible existing comment value
export const submitSelection = async (siteId: string, surveyId: string, answerId: string, questionIndex: number, values: string[], comment?: string): Promise<CommandResult> =>
    (await commandAuthWrapper(`${surveysPath}/${siteId}.${surveyId}/answers/${answerId}/selection`, 'POST', { questionIndex, values, comment }));
